import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { baseUrl } from '../../Data/service/global.service';

@Component({
	selector: 'app-translation-admin',
	templateUrl: './translation-admin.component.html',
	styleUrls: ['./translation-admin.component.scss']
})
export class TranslationAdminComponent implements OnInit {
	translations: any = {};
	selectedLang = localStorage.getItem('curentLang');
	user_type: number = 0;

	newTranslation = { page: '', key: '', value: '' };

	constructor(private http: HttpClient) {}

	ngOnInit() {
	// Set user_type from your auth/user service if needed
	this.user_type = Number(localStorage.getItem('user_type')) || 0;
	if (this.user_type === 200) {
		this.loadTranslations();
	}
	}

	loadTranslations() {
	this.http.get(`${baseUrl}translations/${this.selectedLang}`)
		.subscribe(data => this.translations = data);
	}

	getPages(): string[] {
	return Object.keys(this.translations);
	}

	getTranslationKeys(page: string): string[] {
	return Object.keys(this.translations[page]);
	}

	updateTranslation(page: string, key: string) {
	const translation_value = this.translations[page][key];
	this.http.put(`${baseUrl}translations/${this.selectedLang}`, { page, translation_key: key, translation_value })
		.subscribe(() => this.loadTranslations());
	}

	addTranslation() {
		const { page, key, value } = this.newTranslation;
		if (!page || !key || !value) return;
		this.http.put(`${baseUrl}translations/${this.selectedLang}`, {
			page,
			translation_key: key,
			translation_value: value
		}).subscribe(() => {
			this.loadTranslations();
			this.newTranslation = { page: '', key: '', value: '' };
		});
	}

	removeTranslation(page: string, key: string) {
		this.http.delete(`${baseUrl}translations/${this.selectedLang}?page=${encodeURIComponent(page)}&key=${encodeURIComponent(key)}`)
			.subscribe(() => this.loadTranslations());
	}
}
